import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

import * as _ from 'lodash';
import { AccountService } from '../../../../../common/services/Account.service';
import { UtilityService } from 'app/common/services/Utility.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "account",
    templateUrl: './account.component.html',
    styleUrls: ['./account.css'],
    providers: [AccountService, BsModalService]
})

@Injectable()
export class AccountComponent implements OnInit {
    public currentPage: number = 1;
    public totalRow: number = 0;
    public page_size: number = 10;
    public message: { class: string, content: string } = null;
    public list : any = [];
    public model: any = {};
    public modelFilter: any = {};
    public typeModal : string;
    public modalRef: any = {};
    public modalRef2: any = {};
    public user : any;
    totalItem: any = 0;
    totalPage: any = 0;

    public id_delete : number;


    constructor(
        private accountService : AccountService,
        private modalService : BsModalService,
        private toastr: ToastrService) {
            this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
       this.loadData()
    }


    
    loadData(request: any = {}, sort: any = {}) {
        this.list = [];
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.accountService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.list;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;


            } else {
                this.message = {
                    class: "alert dark alert-danger",
                    content: res.status + ' : ' + res.message
                };
                this.list = [];
                // this.genDataTable();
            }

        }, err => {
            this.toastr.error('Không có quyền', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            this.list = [];
            this.totalItem = 0;
        });
    }

    genKey(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
        }
        return result;
    }

    resetSecretkey(){
        this.model.secretkey = this.genKey(32);
    }

    openModal(template: TemplateRef<any>, account:any) {
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        
        if (account) {
            this.model = Object.assign({}, account);
            if(!this.model.apikey) this.model.apikey = this.genKey(32);
            if(!this.model.secretkey) this.model.secretkey = this.genKey(32);
            this.typeModal = 'edit';
        } else {
            this.model = {
                name: "",
                domain: "",
                limited: 5,
                email: "",
                apikey: this.genKey(32),
                secretkey: this.genKey(32)
            } 
            this.typeModal = 'add';
        }
    }

    isInteger(x) {
        try {
        return parseInt(x, 10) == x;
        } catch(e){
            return 0;
        }
    }

    add() {
        let errMessage = "";
        this.message = null;
        if (!this.model.name || (this.model.name && this.model.name.trim() == "")) {
            errMessage += "Tên doanh nghiệp không được bỏ trống <br/>";
        }
        if (!this.model.domain || (this.model.domain && this.model.domain.trim() == "")) {
            errMessage += "Domain không được bỏ trống <br/>";
        }
        if (!this.model.limited || this.model.limited <= 0) {
            errMessage += "Số lượng chuyên viên sai định dạng <br/>";
        } else {
            if (!this.isInteger(this.model.limited)) {
                errMessage += "Số lượng chuyên viên sai định dạng <br/>";
            }
        }
        if (!this.model.email || (this.model.email && this.model.email.trim() == "")) {
            errMessage += "Email đăng nhập không được bỏ trống <br/>";
        } else {
            if (!UtilityService.validateEmail(this.model.email)) {
                errMessage += "Email đăng nhập không đúng định dạng <br/>";
            }
        }
        if(!this.model.apikey || (this.model.apikey && this.model.apikey.trim() == "")){
            errMessage += "ApiKey không được bỏ trống <br/>";
        }
        if(!this.model.secretkey || (this.model.secretkey && this.model.secretkey.trim() == "")){
            errMessage += "Secret không được bỏ trống <br/>";
        }
        if (!errMessage) {
            this.accountService.create(this.model).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        // this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        // this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        
                        this.loadData();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.toastr.error(error.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            });
        } else {
            this.message = { class: "alert dark alert-danger", content: errMessage };
        }
    }

    edit() {
        let errMessage = "";
        this.message = null;
        if (!this.model.limited) {
            errMessage += "Số lượng chuyên viên không được bỏ trống <br/>";
        } else {
            if (!this.isInteger(this.model.limited)) {
                errMessage += "Số lượng chuyên viên sai định dạng <br/>";
            }
        }

        if(!this.model.apikey || (this.model.apikey && this.model.apikey.trim() == "")){
            errMessage += "ApiKey không được bỏ trống <br/>";
        }
        if(!this.model.secretkey || (this.model.secretkey && this.model.secretkey.trim() == "")){
            errMessage += "Secret không được bỏ trống <br/>";
        }

        let data = {
            limited: this.model.limited,
            apikey: this.model.apikey,
            secretkey: this.model.secretkey
        }
        
        if (!errMessage) {
            this.accountService.update(this.model._id, data).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadData();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        } else {
            this.message = { class: "alert dark alert-danger", content: errMessage };
        }
    }


    search() {
        this.currentPage = 1;
        if(this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
            this.loadData({name: this.modelFilter.keyword});
        }else this.loadData();
    }


    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/account/account.component.ts